document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".menu-item");
  const contentSections = document.querySelectorAll(".content-section");

  menuItems.forEach(item => {
    item.addEventListener("click", () => {
      // Remove active class from all menu items
      menuItems.forEach(i => i.classList.remove("active"));
      item.classList.add("active");

      // Hide all content sections
      contentSections.forEach(section => section.style.display = "none");

      // Show the targeted content
      const targetId = item.getAttribute("data-content");
      document.getElementById(targetId).style.display = "block";
    });
  });
});

// Accordion toggle logic (all start closed)
document.addEventListener("keydown", function (e) {
  if (e.key === "Enter" && e.target.classList.contains("question")) {
    e.target.click();
  }
});

document.addEventListener("click", function (e) {
  if (e.target.classList.contains("question")) {
    const question = e.target;
    const answer = question.nextElementSibling;
    const isOpen = question.classList.contains("active");

    // Close all accordions in this section
    const section = question.closest(".content-section");
    section.querySelectorAll(".question").forEach(q => {
      q.classList.remove("active");
      q.innerHTML = q.innerHTML.replace("–", "+");
      q.nextElementSibling.style.display = "none";
    });

    // Toggle current
    if (!isOpen) {
      question.classList.add("active");
      question.innerHTML = question.innerHTML.replace("+", "–");
      answer.style.display = "block";
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const menuItems = document.querySelectorAll(".menu-item");
  const contentSections = document.querySelectorAll(".content-section");

  function activateTopic(className) {
    const targetItem = document.querySelector('.menu-item.' + className);
    if (!targetItem) return;

    // Set active class
    menuItems.forEach(i => i.classList.remove("active"));
    targetItem.classList.add("active");

    // Show the corresponding content section
    contentSections.forEach(section => section.style.display = "none");
    const targetId = targetItem.getAttribute("data-content");
    const targetContent = document.getElementById(targetId);
    if (targetContent) targetContent.style.display = "block";

    // Collapse all accordions in this panel
    const questions = targetContent.querySelectorAll(".question");
    questions.forEach(q => {
      q.classList.remove("active");
      q.innerHTML = q.innerHTML.replace("–", "+");
      const ans = q.nextElementSibling;
      if (ans) ans.style.display = "none";
    });
  }

  // Event listener for tab clicks (manual switching)
  menuItems.forEach(item => {
    item.addEventListener("click", () => {
      const className = item.classList[1]; // 2nd class should be topic class
      activateTopic(className);
    });
  });

  // Activate via URL ?tag=shipping
  const params = new URLSearchParams(window.location.search);
  const tagParam = params.get("tag");
  if (tagParam) {
    const normalizedTag = tagParam.replace(/_/g, "-");
    activateTopic(normalizedTag);
  }
});



